import { classNames } from '@progress/kendo-react-common';
import { Stepper} from  '@progress/kendo-react-layout';
import { faMemoCircleCheck, faMessagePen, faUserMagnifyingGlass , faExclamationTriangle} from '@fortawesome/pro-solid-svg-icons';
import { DisputeStep, DisputeStepProps } from '../DisputeStep/DisputeStep';
import { DisputeStatus } from 'enums';
import styles from './DisputeStepper.module.scss';

const Received = {
    id: DisputeStatus.Received,
    label: 'Received',
    faIcon: faMessagePen,
};

const InReview = {
    id: DisputeStatus.InReview,
    label: 'In Review',
    faIcon: faUserMagnifyingGlass,
};

const VenderReview = {
    id: DisputeStatus.VendorReview,
    label: 'Review \nRequested',
    faIcon: faExclamationTriangle,
};

const FinalReview = {
    id: DisputeStatus.FinalReview,
    label: 'Final Review',
    faIcon: faUserMagnifyingGlass,
};

const Closed = {
    id: DisputeStatus.Closed,
    label: 'Closed',
    faIcon: faMemoCircleCheck,
}

const mainStepperItems: DisputeStepProps[] = [Received, InReview, Closed];
const finalStepperItems: DisputeStepProps[] = [Received, FinalReview, Closed];
const vendorStepperItems: DisputeStepProps[] = [Received, VenderReview, Closed];

const getStepperItems = (status: DisputeStatus) => {
    switch (status) {
        case DisputeStatus.VendorReview: return vendorStepperItems;
        case DisputeStatus.FinalReview: return finalStepperItems;
        default: return mainStepperItems;
    };
};

export type DisputeStepperProps = {
    className?: string,
    disputeStatus: DisputeStatus,
};

export const DisputeStepper = ({ className, disputeStatus }: DisputeStepperProps) => {
    const stepperItems = getStepperItems(disputeStatus);
    const index = stepperItems.findIndex(({ id }) => id === disputeStatus);
    const items = stepperItems
        .map((step, idx) => ({
            ...step,
            done: index > idx,
        }));

    return <Stepper className={classNames(styles.stepper, className)} linear value={index} item={DisputeStep} items={items} />;
};